import PropTypes from "prop-types"
import React, { useEffect, useRef } from "react"
import styled from "styled-components"

import { isTestMode } from "helpers/application"

/*global affirm*/

const AffirmLink = styled.a`
  color: ${(props) => props.theme.colors.link};
  cursor: pointer;
  display: block;
  font-size: 12px;
  min-height: 18px;
  & > span {
    border-bottom: 1px solid;
  }
`

const Affirm = ({ price }) => {
  const affirmPriceRef = useRef()

  useEffect(() => {
    if (!isTestMode) {
      dataLayer.push({
        event: "load-affirm",
      })
    }
  }, [])

  return (
    <AffirmLink>
      <span
        className="affirm-as-low-as"
        // data-affirm-color={logoColor}
        data-amount={price}
        data-learnmore-show="false"
        data-page-type="product"
        ref={() => {
          if (
            typeof affirm !== "undefined" &&
            affirm.ui &&
            affirm.ui.refresh &&
            affirmPriceRef.current != price
          ) {
            affirm.ui.refresh()
            affirmPriceRef.current = price
          }
        }}
      />
    </AffirmLink>
  )
}

Affirm.propTypes = {
  price: PropTypes.number,
}

export default Affirm
